import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const deskBooking = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  getAllDesksWithTheirBookings(term, locationId, currentDate) {
    let url = `api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desks/active?date=${currentDate}`
    if (term) {
      url = url.concat(`&term=${term}`)
    }
    if (locationId) {
      url = url.concat(`&locationid=${locationId}`)
    }
    return Axios.get(url)
  },
  getAuditLogs(deskId, currentDate) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desks/${deskId}/audit?date=${currentDate}`)
  },
  createNewBooking(locationId, deskId, body) {
    return Axios.post(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/desks/${deskId}/bookings`, body)
  },
  markBookingAsCheckedIn(locationId, deskId, bookingId) {
    return Axios.put(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/desks/${deskId}/bookings/${bookingId}/checkin`)
  },
  markBookingAsCheckedInOfAnUser(locationId, deskId, bookingId) {
    return Axios.put(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations/${locationId}/desks/${deskId}/bookings/${bookingId}/checkin`)
  },
  markBookingAsCheckedOut(locationId, deskId, bookingId) {
    return Axios.put(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/desks/${deskId}/bookings/${bookingId}/checkout`)
  },
  markBookingAsCheckedOutOfAnUser(locationId, deskId, bookingId) {
    return Axios.put(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations/${locationId}/desks/${deskId}/bookings/${bookingId}/checkout`)
  },
  deleteBooking(locationId, deskId, bookingId) {
    return Axios.delete(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/desks/${deskId}/bookings/${bookingId}`)
  },
  deleteBookingOfAnUser(locationId, deskId, bookingId) {
    return Axios.delete(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations/${locationId}/desks/${deskId}/bookings/${bookingId}`)
  },
  saveBookingOfAnUser(locationId, deskId, body) {
    return Axios.post(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations/${locationId}/desks/${deskId}/bookings`, body)
  },
  createRecurrencyBooking(locationId, body) {
    return Axios.post(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations/${locationId}/desks/bulk-bookings`, body, {
      ignoreGlobalCatch: true,
    })
  },
  createBookingOfAnInvite(inviteId, body) {
    return Axios.post(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/invites/${inviteId}/bookings`, body, {
      ignoreGlobalCatch: true,
    })
  },
  getUserBookedDates(start, finish) {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/desk-bookings?start=${start}&finish=${finish}`, {
      ignoreGlobalCatch: true,
    })
  }
}

export default deskBooking
